<!-- <template>
  <div class="hide-sm">
    <v-tooltip bottom :open-on-focus="false">
      <template #activator="{ on: onTooltip }">
        <v-btn icon v-on="{ ...onTooltip }" @click="changeTheme">
          <i
            class="p-fs-xxxxl text-p-dark"
            :class="{ 'pi pi-moon': themeMode === 'dark', 'pi pi-sun': themeMode === 'default' }"
          ></i>
        </v-btn>
      </template>
      <span>{{ label.button.themeConfigurator }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/lang/StaticLabels.js";

export default {
  name: "ThemConfigurator",
  data() {
    return {
      label,
    };
  },
  computed: {
    ...mapGetters({
      themeMode: "themeMode",
    }),
  },
  methods: {
    changeTheme() {
        let mode;
        if(this.themeMode === "default") {
          mode = "dark";
        } else {
          mode = "default";
        }
        this.$store.commit("changeThemeMode", mode);
        localStorage.setItem("mitaThemeMode", mode);
        const route = this.$router.resolve(this.$route);
        const absoluteURL = new URL(route.href, window.location.origin + window.location.pathname).href;
        window.location.href = absoluteURL;
    },
  },
  mounted() {
      let theme = localStorage.getItem("mitaThemeMode");
      if(theme) {
        this.$store.commit("changeThemeMode", theme);
      }
  }
};
</script> -->
<template>
  <div class="theme-toggle" @click="toggleTheme">
    <div class="toggle-track" :class="{ dark: isDark }">
      <div class="toggle-thumb">
        <i :class="isDark ? 'pi pi-moon p-fs-n' : 'pi pi-sun'"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ThemeSwitch",
  computed: {
    ...mapGetters({
      themeMode: "themeMode",
    }),
    isDark() {
      return this.themeMode === "dark";
    },
  },
  methods: {
    toggleTheme() {
      const newMode = this.isDark ? "default" : "dark";
      this.$store.commit("changeThemeMode", newMode);
      localStorage.setItem("mitaThemeMode", newMode);

      document.body.classList.toggle("dark-theme", newMode === "dark");
    },
  },
  mounted() {
    const saved = localStorage.getItem("mitaThemeMode") || "default";
    this.$store.commit("changeThemeMode", saved);

    document.body.classList.toggle("dark-theme", saved === "dark");
  },
};
</script>
<style>
.theme-toggle {
  cursor: pointer;
  width: 50px;
  height: 23px;
  display: flex;
  align-items: center;
}

.toggle-track {
  background-color: #f1f5f9;
  border-radius: 999px;
  width: 100%;
  height: 100%;
  position: relative;
  transition: background-color 0.3s;
  border: none;
}

.toggle-track.dark {
  background-color: var(--color-border);
  border: 1px solid var(--color-filter-grid);
}

.toggle-thumb {
  background-color: #fff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: left 0.3s, background-color 0.3s;
  font-size: var(--font-size-xslarge);
}

.toggle-track.dark .toggle-thumb {
  left: 25px;
  background-color: var(--color-filter-grid);
  color: white;
  top: 1px
}
</style>
